var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0435 0.000220328H2.95646C1.34414 -0.0190595 0.0208713 1.26339 0 2.86555V37.1354C0.0209921 38.7375 1.34426 40.0196 2.95646 39.9998H37.0435C38.656 40.0197 39.9795 38.7372 40 37.1349V2.86555C39.9794 1.26327 38.656 -0.0193195 37.0435 0.000220328ZM12.1265 33.4838H6.08443V15.422H12.1265V33.4838ZM9.60106 12.9592C9.43608 12.971 9.2705 12.9701 9.10576 12.9561H9.06607C7.33007 13.0601 5.83788 11.7461 5.73322 10.021C5.62856 8.29591 6.95096 6.81314 8.68699 6.70914C8.83981 6.69998 8.99323 6.70194 9.14581 6.71488C10.8811 6.59001 12.3896 7.88663 12.5154 9.61097C12.6411 11.3352 11.3362 12.8343 9.60106 12.9592ZM33.9109 33.4837H27.8698V23.8222C27.8698 21.3938 26.9951 19.7377 24.8094 19.7377C23.4131 19.7457 22.1723 20.6246 21.7094 21.9337C21.5547 22.406 21.4873 22.902 21.5103 23.3983V33.4837H15.4693C15.4693 33.4783 15.5485 17.1165 15.4699 15.4223H21.511V17.9822C22.6243 16.0568 24.7231 14.9067 26.9559 14.9985C30.9307 14.9985 33.9109 17.58 33.9109 23.1277V33.4837H33.9109Z",
    fill: "#1890FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.96c9cd3d135b02b300dd2498604b3d1b.svg";
export { ForwardRef as ReactComponent };